// ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    // if ("scrollRestoration" in window.history) {
    //   window.history.scrollRestoration = "manual";
    // }
    if (navigationType === "POP") return;

    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // const scrollToTop = () => {
    //   // Main window scroll
    //   window.scrollTo(0, 0);
    //   // Extra safety for Safari / iOS
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;

    //   // If app uses a scrollable container, handle that too
    //   const scrollContainer = document.querySelector("[data-scroll-container]");
    //   if (scrollContainer) {
    //     scrollContainer.scrollTop = 0;
    //   }
    // };

    // // Run after layout, and once more just in case
    // scrollToTop();
    // const id = setTimeout(scrollToTop, 0);

    // return () => clearTimeout(id);
  }, [pathname, navigationType]);

  return null;
}
